'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dataPoint = require('../../../atoms/data-point');

var _dataPoint2 = _interopRequireDefault(_dataPoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
// TODO: Change this to building blocks to remove the necessity of declaring
// renderPara, etc.

var renderDataPoint = function renderDataPoint(dataPoint) {
  if (dataPoint) {
    return _react2.default.createElement(_dataPoint2.default, _extends({}, dataPoint, { className: 'data-point-panel__data-point' }));
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'data-point-panel__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var DataPointPanel = function DataPointPanel(props) {
  var _props$content = props.content,
      dataPoint = _props$content.dataPoint,
      paragraph = _props$content.paragraph;


  var moleculeClasses = (0, _classnames2.default)('data-point-panel', props.className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    renderDataPoint(dataPoint),
    renderParagraph(paragraph)
  );
};

exports.default = DataPointPanel;


DataPointPanel.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    dataPoint: _propTypes2.default.shape({
      stats: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      description: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  className: _propTypes2.default.string
};

DataPointPanel.defaultProps = {
  config: {
    type: 'DataPointPanel'
  },
  content: {
    dataPoint: {
      stats: {
        text: '179M'
      },
      description: {
        text: 'Active users'
      }
    },
    paragraph: {
      text: '130 characters maximum for paragraph text which should ' + 'equal less than 4 lines of text, sentence case, normal punctuation.'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/data-point-panel/jsx/DataPointPanel.js
// module id = 563
// module chunks = 4